// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zhic","name":"styles_name__fVNsQ","phone":"styles_phone__3h6AR"};